import { useEffect, useState } from "react";

const DefaultValuesMap = {
  number: 1,
  text: "",
  password: "",
  email: "",
}

const defaulTransformationMap = {
  number: (value) => parseInt(value, 10),
  text: (value) => value,
  password: (value) => value,
  email: (value) => value,
}

export function DebouncedInput({
  value,
  onChange,
  debounceTimeout = 500,
  ...inputProps
}){
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (event) => {
    const transform = defaulTransformationMap[inputProps.type];
    setInputValue(
      transform(
        event.target.value || DefaultValuesMap[inputProps.type]
      )
    );
  };

  useEffect(() => {
    if (value !== undefined && value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      onChange(inputValue);
    }, debounceTimeout);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, debounceTimeout]);

  return (
    <input
      {...inputProps}
      value={inputValue}
      onChange={handleInputChange}
    />
  );
}